export const dailyActivities = [
  {
    id: 1,
    type: 'craft',
    title: '✨ Make a Rainbow Bookmark',
    description: 'Create a colorful bookmark using paper strips and glitter glue!',
    duration: '15 mins',
    materials: ['Colored paper', 'Glue', 'Glitter', 'Ribbon'],
    icon: '🌈'
  },
  {
    id: 2,
    type: 'game',
    title: '🔍 Cloud Shape Hunt',
    description: 'Look outside and find 5 cloud shapes! Draw them in your diary.',
    duration: '10 mins',
    materials: ['Go outside', 'Your imagination'],
    icon: '☁️'
  },
  {
    id: 3,
    type: 'recipe',
    title: '🧁 Microwave Mug Cake',
    description: 'Make a yummy chocolate mug cake in just 2 minutes!',
    duration: '5 mins',
    materials: ['Mug', 'Flour', 'Sugar', 'Cocoa powder', 'Milk'],
    recipe: [
      '4 tbsp flour',
      '4 tbsp sugar',
      '2 tbsp cocoa',
      '1 egg',
      '3 tbsp milk',
      '3 tbsp oil',
      'Mix in mug, microwave 90 seconds!'
    ],
    icon: '🍫'
  },
  {
    id: 4,
    type: 'story',
    title: '📖 Mystery Mini Story',
    description: 'Read a 3-minute mystery and solve the case!',
    duration: '5 mins',
    story: 'The Case of the Missing Cookie...',
    icon: '🕵️'
  },
  {
    id: 5,
    type: 'art',
    title: '🎨 Doodle Challenge',
    description: 'Turn these random shapes into something magical!',
    duration: '10 mins',
    materials: ['Paper', 'Pencil', 'Colors'],
    icon: '✏️'
  },
  {
    id: 6,
    type: 'music',
    title: '🎵 Make Up a Song',
    description: 'Create a silly song about your favorite animal!',
    duration: '10 mins',
    icon: '🎤'
  },
  {
    id: 7,
    type: 'science',
    title: '🔬 Magic Milk Experiment',
    description: 'See colors dance with milk, soap, and food coloring!',
    duration: '10 mins',
    materials: ['Milk', 'Food coloring', 'Dish soap', 'Plate'],
    icon: '🌈'
  },
  {
    id: 8,
    type: 'trivia',
    title: '🧠 Fun Fact Challenge',
    description: 'Learn 5 amazing facts about animals!',
    duration: '5 mins',
    icon: '🦄'
  }
];

export const getRandomActivity = () => {
  const randomIndex = Math.floor(Math.random() * dailyActivities.length);
  return dailyActivities[randomIndex];
};

export const funFacts = [
  "A group of flamingos is called a 'flamboyance'! 🦩",
  "Butterflies can taste with their feet! 🦋",
  "Bananas are berries, but strawberries aren't! 🍌",
  "A single cloud can weigh more than 1 million pounds! ☁️",
  "Otters hold hands while sleeping so they don't drift apart! 🦦",
  "Stars don't actually twinkle - it's just our atmosphere! ✨",
  "Honey never spoils! Ancient honey is still edible! 🍯",
  "Penguins can jump 6 feet high! 🐧",
  "Dolphins have names for each other! 🐬",
  "A shrimp's heart is in its head! 🦐"
];

export const getRandomFact = () => {
  return funFacts[Math.floor(Math.random() * funFacts.length)];
};
